<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <my-form
        ref="formRef"
        :data.sync="data"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <b-row>
        <b-col cols="12" class="my-form_btns">
          <p class="text-secondary">
            {{ explain }}
          </p>
          <b-button
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click="send"
          >
            {{ $t('_components.btns.send') }}
          </b-button>
          <b-button
            v-if="formId != 29"
            variant="outline-primary"
            :disabled="loading"
            @click="saveDrafts"
          >
            {{ $t('_components.btns.saveDrafts') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <component
      :is="flowKey"
      v-else
      :process-key="processKey"
      :explain="explain"
      @cancel="handleCustFormCancel"
      @close="$emit('close')"
    />
    <c-modal
      :visible="showTip"
      :title="$t('_components').tips"
      :message="$t('_components').message.ticketMsg"
      :selected-columns="removeRow"
      @close="() => (showTip = false)"
      @modelConfirm="handleTipConfirm"
    />
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'
import applyAPI from '@/api/apply/index'
import vacationAPI, { getAnnualDays } from '@/api/worker/vacation'
import templateFormAPI from '@/api/templateForm/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CModal from '@/components/crud/modal.vue'
import website from '@/config/website'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import { mapGetters } from 'vuex'
// custForm
import Induction from '@/views/apply/components/custForm/induction.vue'
import WORKER from '@/api/worker/index'
import { getDetail } from '@/api/system/post'
import { processOption } from '@/config/processOption'
import { deepClone } from '@/util/util'
import { Return } from '@icon-park/vue'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
    CModal,
  },
  props: {
    formId: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      fromShow: true,
      flowKey: '',
      form: {
        isPass: false,
      },
      showTip: false,
      isDrafts: false,
      loading: false,
      data: {
        // 已用假期时长, 剩余假期时长, 是否离开新加坡
        usedDaysTitle: null,
        haveDaysTitle: null,
        isLeave: null,
        workerId: undefined,
        leaveStartTime: '',
        leaveEndTime: '',
        leaveUnit: '1',
      },
      columns: [],
      hasDept: false,
      staffQueryParams: {
        8: {
          status: 1,
        },
        7: {
          status: 1,
        },
        1: {
          status: 1,
        },
      },
      baseData: [],
      allTempList: [],
    }
  },
  computed: {
    ...mapGetters(['userAllInfo', 'courseList']),
    workerId() {
      return this.userAllInfo.workerId
    },
    staffId() {
      return this.userAllInfo.staffId
    },
    option() {
      const columns = []
      const { data } = this
      this.columns.forEach((item) => {
        const dictQuery = {}
        const temp = item
        if (this.formId === '39') {
          if (item.dictCode === 'trade') {
            temp.formOption.disabled = !this.data.specialistCode
            temp.disabled = !this.data.specialistCode
            if (!this.data.specialistCode) {
              temp.formOption.small =
                this.$t('_components.placeholder.firstSelect') +
                this.i18n('labelEmployment.specialistId')
            }
            dictQuery.specialistId = this.data.specialistCode
          }
        }

        if (this.formId === '24') {
          // 离职
          if (item.dictCode === 'trade') {
            dictQuery.specialistId = this.data.specialistId
          }
          if (item.field === 'lastWorkingDay') {
            const currentDate = moment()
              .add(7, 'd')
              .format('YYYY-MM-DD')
            temp.formOption.minDate = currentDate
          }
          if (item.field === 'remark') {
            if (
              this.data.resignation &&
              this.data.resignation.length &&
              this.data.resignation.includes('5')
            ) {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
              this.data.remark = ''
            }
          }
        }

        if (this.formId === '28') {
          // 护照
          if (item.field === 'useDate') {
            temp.formOption.minDate = moment(new Date()).format('YYYY-MM-DD')
          }
          if (item.field === 'returnDate') {
            temp.formOption.minDate = moment(new Date()).format('YYYY-MM-DD')

            if (
              this.data.passport_application_reason &&
              this.data.passport_application_reason !== '2'
            ) {
              const maxDate = moment(this.data.useDate)
                .add(7, 'd')
                .format('YYYY-MM-DD')
              temp.formOption.maxDate = maxDate

              console.log(temp.formOption.maxDate, 'maxDate++=')
              // this.$forceUpdate()
            }
          }
        }

        if (this.formId === '29') {
          // 请假
          if (
            item.field === 'departureDate' ||
            item.field === 'arrivalDate' ||
            item.field === 'tickets'
          ) {
            temp.formOption.hide = Number(data.isLeave) !== 1
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            // temp.formOption.minDate = new Date()
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
          if (item.field === 'leaveStartTime') {
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
          if (item.field === 'leaveEndTime') {
            if (this.data.leaveUnit === '0.5') {
              temp.formOption.hide = true
              this.data.leaveEndTime = ''
            } else {
              temp.formOption.hide = false
            }
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
          if (item.field === 'leavePeriod') {
            if (this.data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }

          if (item.field === 'leaveUnit') {
            if (this.data.minLeaveUnit === '0.5') {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
            }
          }

          if (item.field === 'usedDays') {
            temp.formOption.numberMax = 60
            temp.formOption.numberMin = 0
            if (this.data.leaveUnit === '0.5') {
              temp.formOption.disabled = true
              // this.data.usedDays = '0.5'
            }
          }
        }

        if (this.formId === '27') {
          if (item.field === 'isRenew') {
            if (this.data.course_type) {
              const courseInfo = this.courseList.find(
                (el) => el.dictKey === this.data.course_type
              )
              const isCoretrade = /Coretrade.+/g.test(courseInfo.dictValue)
              if (isCoretrade) {
                temp.formOption.hide = false
              } else {
                temp.formOption.hide = true
                this.data.isRenew = ''
              }
            }
          }
        }

        // 课程申请
        if (item.field === 'startDate') {
          const currentDate = moment(new Date()).format('YYYY-MM-DD')
          temp.formOption.minDate = `${currentDate} 00:00:00`
        }
        if (item.field === 'endDate') {
          const currentDate = moment(new Date()).format('YYYY-MM-DD')
          temp.formOption.minDate = `${currentDate} 00:00:00`
        }
        // 简略转场申请
        // if (this.formId === '34' && item.field === 'teamId') {
        //   dictQuery.teamCode = this.data.teamCode
        // }
        if (this.formId === '34' && item.field === 'workerIds') {
          dictQuery.teamCode = this.data.teamCode
        }

        temp.formOption.dictQuery = dictQuery
        // temp.dictQuery = dictQuery
        // if (this.formId === '34') {
        //   console.log(temp.formOption, 'temp.formOption++=')
        // }
        columns.push(temp)
      })
      const option = {
        columns,
      }
      return option
    },
    // 根据工人或员工id动态获取假期时长
    vacationDayParams() {
      return {
        workerId: this.data.workerId,
        vacationInfoId: this.data.vacationInfoId,
      }
    },
  },
  // 监听假期时长
  watch: {
    vacationDayParams: {
      deep: true,
      immediate: true,
      handler(e) {
        if (e.workerId && e.vacationInfoId) {
          this.getVacationDay(e)
          this.data.leaveDays = 2
        }
      },
    },
    'data.isLeave': {
      handler(e) {
        console.log('isLeave', e)
        if (this.formId == 29 && e != 1) {
          this.data.tickets = []
          this.refreshTmplate()
        }
        if (this.formId != 24) {
          this.data.arrivalDate = ''
        }

        this.data.departureDate = ''
      },
      deep: true,
    },
    'data.workerId': {
      handler(e) {
        if (String(this.formId) === '42' && e) {
          this.getDismissalWorkerInfo(e)
        }
      },
      deep: true,
    },
    'data.passport_application_reason': {
      handler() {
        this.data.returnDate = ''
        this.refreshTmplate()
      },
    },

    'data.vacationInfoId': {
      handler(newVal, oldVal) {
        if (!oldVal || newVal === oldVal) {
          return
        }
        this.data.leaveStartTime = ''
        this.data.leaveEndTime = ''
        this.data.leaveUnit = '1'
        this.data.usedDays = 0
        this.refreshTmplate()
      },
    },
    'data.leaveStartTime': {
      handler(newVal) {
        if (!newVal) {
          return
        }
        if (this.data.leaveUnit === '0.5' && this.data.vacationInfoId) {
          this.data.leaveEndTime = ''
          this.getSunDay()
          return
        }
        if (this.data.leaveEndTime && this.data.vacationInfoId) {
          this.getSunDay()
        }
      },
    },
    'data.leaveEndTime': {
      handler(newVal) {
        if (!newVal) {
          return
        }
        if (this.data.leaveStartTime && this.data.vacationInfoId) {
          this.getSunDay()
        }
      },
    },
    'data.leaveUnit': {
      handler() {
        this.data.leaveStartTime = ''
        this.data.leaveEndTime = ''
        this.data.usedDays = 0
        this.refreshTmplate()
      },
    },
    'data.remark': {
      handler(oldVal, newVal) {
        this.refreshTmplate()
      },
    },
  },
  mounted() {
    if (this.formId) {
      if (this.formId === '27') {
        this.onLoad(this.formId)
      } else {
        this.getDetailData()
      }
    }
  },
  methods: {
    async getDetailData() {
      let baseData = {}
      this.data.applicationDate = moment().format('YYYY-MM-DD')
      // 申请人是员工
      if (this.staffId && this.staffId !== -1) {
        const { data } = await WORKER.getStaffInfo({ staffId: this.staffId })
        // eslint-disable-next-line prefer-destructuring
        baseData = data.data.records[0]
        this.data.name = baseData.enName
        this.data.contact = baseData.mobile
        this.data.code = baseData.staffNo
        if (this.formId === '39') {
          this.data.signAttach = this.userAllInfo.staffInfo.signAttach
        }
      } else {
        // 申请人是工人
        const { data } = await WORKER.getWorkBaseDetail({
          workerID: this.workerId,
        })
        baseData = data.data
        this.baseData = baseData
        this.data.unitId = baseData.employmentVO.unitId
        this.data.unitName = baseData.employmentVO.unitName
        this.data.name = baseData.infoVO.name
        this.data.code = baseData.infoVO.employmentCode
        this.data.employmentCode = baseData.infoVO.employmentCode
        this.data.workerId = this.workerId
        this.data.projectId = String(baseData.infoVO.projectId)
        this.data.specialistId = String(baseData.employmentVO.specialistId)
        this.data.wpNumber = baseData.employmentVO.wpNumber
        this.data.wpExpiryDate = baseData.employmentVO.wpExpiryDate
        this.data.contact = baseData.infoVO.mobile
        this.data.teamLeaderId = baseData.employmentVO.teamLeaderId
        this.data.tradeId = baseData.employmentVO.trade
        if (this.formId === '39') {
          // this.data.sign = baseData.infoVO.signType
          this.data.signAttach = baseData.infoVO.signType
        }
        if (this.formId === '42') {
          this.data.wpExpiryDate = null
          this.data.projectId = null
          this.data.contact = null
          this.data.code = null
          this.data.workerId = ''
          this.data.employmentCode = null
          this.data.arrivalDate = null
          // this.data.emergencyContact = null
          this.data.unitName = null
          this.data.wpNumber = null
          this.data.applicationDate = null
          this.data.tradeId = null
          this.data.teamLeaderId = null
        }
      }

      this.data.applicationDate = moment().format('YYYY-MM-DD')
      if (this.formId === '24') {
        this.data.arrivalDate = baseData.employmentVO.joinDate
      }
      if (this.formId === '34') {
        this.data.teamCode = baseData.employmentVO.teamCode
        this.data.teamId = baseData.employmentVO.teamCode
      }
      // if (this.formId === '27') {
      //   this.data.applicationDate = moment(new Date()).format('YYYY-MM-DD')
      // }

      // this.data.applicationDate = moment().format('YYYY-MM-DD')
      this.onLoad(this.formId)
    },
    async getDismissalWorkerInfo(workerId) {
      const { data } = await WORKER.getWorkBaseDetail({ workerID: workerId })
      const baseData = data.data
      this.baseData = baseData
      this.data.unitId = baseData.employmentVO.unitId
      this.data.unitName = baseData.employmentVO.unitName
      this.data.name = baseData.infoVO.name
      this.data.code = baseData.infoVO.employmentCode
      this.data.employmentCode = baseData.infoVO.employmentCode
      this.data.projectId = String(baseData.infoVO.projectId)
      this.data.specialistId = String(baseData.employmentVO.specialistId)
      this.data.wpNumber = baseData.employmentVO.wpNumber
      this.data.wpExpiryDate = baseData.employmentVO.wpExpiryDate
      this.data.contact = baseData.infoVO.mobile
      this.data.teamLeaderId = baseData.employmentVO.teamLeaderId
      this.data.tradeId = baseData.employmentVO.trade
      this.data.arrivalDate = baseData.employmentVO.joinDate
      this.refreshTmplate()
    },
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit')
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        const setDictQuery = (item) => {
          const dictQuery = {}
          return dictQuery
        }
        // const setDictQuery = item => {
        //   let dictQuery = {}
        //   if (item.dictCode === 'post') {
        //     dictQuery.deptId = this.data.deptId
        //   }
        //   return dictQuery
        // }
        this.allTempList = temp
        this.columns = templateFormat(temp, setDictQuery) // , setDictQuery)
      })
    },
    send() {
      console.log('sssssss', this.data)
      this.isDrafts = false
      if (
        this.formId == 29 &&
        this.data.isLeave &&
        this.data.isLeave == 1 &&
        (!this.data.tickets || this.data.tickets.length < 1)
      ) {
        this.showTip = true
      } else {
        this.$refs.formRef.validationForm()
      }
    },
    handleTipConfirm() {
      this.showTip = false
      this.$refs.formRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.formRef.validationForm()
    },
    arrayToStr(arr) {
      return arr.join(',')
    },
    // 刷新流程模板
    refreshTmplate() {
      this.columns = templateFormat(this.allTempList)
    },
    getSunDay() {
      const allDays =
        moment(this.data.leaveEndTime).diff(this.data.leaveStartTime, 'day') + 1

      // 工作日判断
      const sunDays = 0
      console.log('this.data.calculationType', this.data.calculationType)
      if (this.data.calculationType === 1 ) {
        let isHalf = 1
        if (this.data.minLeaveUnit === '0.5') {
          isHalf = 1
        }
        const endTime =
          this.data.leaveUnit === '0.5'
            ? this.data.leaveStartTime
            : this.data.leaveEndTime
        getAnnualDays({
          startDate: this.data.leaveStartTime,
          endDate: endTime,
          vacationInfoId: this.data.vacationInfoId,
          isHalf,
        }).then((res) => {
          console.log(this.data, res.data.data,'this.data.roundUp', this.data.leaveUnit === '0.5' && res.data.data >= 1 && !this.data.roundUp)
          this.data.usedDays =
            this.data.leaveUnit === '0.5' && res.data.data >= 1 && !this.data.roundUp
              ? 0.5
              : res.data.data
          this.refreshTmplate()
        })
        // if (this.data.leaveUnit === '0.5') {
        //   // this.data.leaveEndTime = ''
        //   this.data.usedDays = '0.5'
        // } else {
        //   getAnnualDays({
        //     startDate: this.data.leaveStartTime,
        //     endDate: this.data.leaveEndTime,
        //     isHalf,
        //   }).then((res) => {
        //     this.data.usedDays = res.data.data
        //     this.refreshTmplate()
        //   })
        // }
      }
      // 自然日判断
      if (this.data.calculationType === 2 ) {
        this.data.usedDays = this.data.leaveUnit === '0.5' && !this.data.roundUp ? 0.5 : allDays
      }

      this.refreshTmplate()
    },
    handleSubmit(form) {
      this.loading = true
      if (form.vacationInfoId === '1476046375170916315') {
        if (form.usedDays > form.haveDaysTitle) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_worker.labelVacation.vacationError'),
              icon: 'BellIcon',
              text: this.$t('_worker.labelVacation.vacationErrorTip'),
              variant: 'danger',
            },
          })
          return
        }
      }

      const params = templateSubmitFormat(form, this.columns)
      Object.entries(params).forEach((item) => {
        if (item[0] !== 'files') {
          params[item[0]] = Array.isArray(item[1]) ? item[1].join(',') : item[1]
        }
      })
      params.processKey = this.processKey
      params.formId = this.formId
      const router = website.staffProcessRouter

      // const findUploads = this.columns.filter(o => o.type === 'upload')
      // findUploads.forEach(findUpload => {
      //   if (Array.isArray(params[findUpload.field])) {
      //     let key = findUpload.field
      //     if (findUpload.field === 'files') {
      //       key = 'fileIds'
      //     }
      //     params[key] = params[findUpload.field].map(o => o.attachId).join()
      //   }
      //   if (findUpload.field === 'files') {
      //     delete params[findUpload.field]
      //   }
      // })
      console.log(this.formId)
      if (this.formId == 29 && this.data.forceUploadAttach && !params.fileIds) {
        console.log(params, 'ssssssssssssss')
        this.loading = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.userNotupload'),
            variant: 'danger',
          },
        })
        return
      }

      if (this.isDrafts) {
        const option = processOption[this.formId]
        applyAPI.workerSaveAndStart(params).then((res) => {
          this.loading = false
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      } else {
        const option = processOption[this.formId]
        applyAPI
          .workerAdd(params, { option: JSON.stringify(option) })
          .then((res) => {
            this.loading = false
            this.$emit('close')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
          })
          .catch((err) => {
            this.loading = false
          })
      }
    },
    // 获取假期时长
    getVacationDay(params) {
      const year = moment(new Date()).format('YYYY')
      const tempParams = { ...params, year }
      vacationAPI.vacationDetail(tempParams).then((res) => {
        const temp = res.data.data || {}
        const haveDays = Number(temp.haveDays) || 0
        const usedDays = Number(temp.usedDays) || 0
        const pendingDays = Number(temp.pendingDays) || 0
        this.data.usedDaysTitle = parseFloat(usedDays)
        this.data.pendingDays = parseFloat(pendingDays)
        this.data.haveDaysTitle = parseFloat(haveDays - usedDays - pendingDays)
        this.data.minLeaveUnit = temp.minLeaveUnit
        this.data.generateType = temp.generateType
        this.data.forceUploadAttach = temp.forceUploadAttach || false
        // 自然日 工作日
        this.data.calculationType = temp.calculationType
        this.data.roundUp = temp.roundUp || false
        this.refreshTmplate()
      })
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-add-form {
  height: 100%;
  position: relative;
  .my-form {
    height: calc(100% - 100px);
    position: relative;
    overflow: hidden;
    &_btns {
      left: 0;
      right: 0;
      position: absolute;
      bottom: 0;
      text-align: center;
      border-top: 1px solid #ebe9f1;
      background: #fff;
      padding: 1.5rem 0;
    }
  }
}
</style>
